module.exports = __webpack_public_path__ + "static/user_profile_screen-b71395335e6386a5876b30f61afc30c5.png";